// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";

import FormContainerWithLogo from "src/components/auth/FormContainerWithLogo";
import ForgotPassword from "src/components/auth/ForgotPassword";
import ResetPassword from "src/components/auth/ResetPassword";
import ResetRequestSent from "src/components/auth/ResetRequestSent";
import ResetSuccess from "src/components/auth/ResetSuccess";
import MobileWebLanding from "src/components/auth/MobileWebLanding";
import SignIn from "src/components/auth/SignIn";
import EmailNotVerified from "src/components/auth/EmailNotVerified";
import LoaderWrapper from "src/components/auth/LoaderWrapper";
import VerificationMail from "src/components/auth/VerificationMail";
import Loader from "src/components/Loader";

import { getLocationPayload, getIsAuthenticationChecked } from "src/reducers";
import type { Location, AppState } from "src/types";

const VerifyResetCode = () => <Loader>{i18n.t(k.VERIFYING_YOUR_LINK)}</Loader>;

const pages = {
  default: SignIn,
  forgot: ForgotPassword,
  "reset-sent": ResetRequestSent,
  "verify-reset": VerifyResetCode,
  "not-verified": EmailNotVerified,
  reset: ResetPassword,
  "reset-success": ResetSuccess,
  mobile: MobileWebLanding,
  "verification-mail": VerificationMail,
};

type Props = {
  page?: string,
  isAuthenticationChecked: boolean,
};

const AuthComponent = ({ page = "", isAuthenticationChecked }: Props) => {
  const Component = R.prop(page || "default")(pages);
  return (
    <FormContainerWithLogo>
      {isAuthenticationChecked ? (
        <LoaderWrapper>
          <Component />
        </LoaderWrapper>
      ) : (
        <Loader />
      )}
    </FormContainerWithLogo>
  );
};

const mapStateToProps = ({
  app,
  location,
}: {
  app: AppState,
  location: Location,
}) => ({
  page: getLocationPayload("page")(location),
  isAuthenticationChecked: getIsAuthenticationChecked(app),
});

const Auth = connect(mapStateToProps, {})(AuthComponent);

export default Auth;
